export const UX_LOADING = {
    inlineSpinnerSize: 16,
    sectionSpinnerSize: 24,
    routeSpinnerSize: 22,
    sectionMinHeight: "20vh",
    pageMinHeight: "40vh",
} as const;

export const UX_MOTION = {
    microMs: 160,
    standardMs: 220,
    panelMs: 280,
    easingStandard: "cubic-bezier(0.2, 0, 0, 1)",
} as const;

export function motionMs(ms: number): string {
    return `${ms}ms`;
}
